/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-03-18 11:39:10
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-07-29 10:33:31
 * @FilePath: /designcenter/src/views/designCenter/store/graphStore.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia'

import type LogicFlow from '@logicflow/core'
import type { NodeData, EdgeData } from '@logicflow/core'
import { getDataCache } from '@/utils'

const cache = getDataCache()
export const useGraphStore = defineStore('graph', {
  state: () => ({
    logicFlow: null as LogicFlow | null,
    nodes: null as NodeData[] | null,
    edges: null as EdgeData[] | null,

    // 缩放和移动
    transform: {
      SCALE_X: 1,
      SCALE_Y: 1,
      TRANSLATE_X: 0,
      TRANSLATE_Y: 0,
    },

    // 编辑模式
    editMode: 'select' as 'select' | 'drag' | 'node' | 'text' | 'line' | 'shape',

    // 是否显示网格
    showGrid: false,

    // 是否只读
    readOnly: false,

    //是否为模板
    isTemplate: false,

    //是否展示抽屉面板
    showDrawerPanel: false,

    //是否展示放置产品
    showPlaceDevices: false,

    //抽屉组件类型
    drawerComponentType: '',

    //当前文字节点字体大小
    currentTextSize: 18,

    //当前文字节点id
    currentTextNodeId: '',

    //当前产品id
    currentProductId: '',

    //当前节点id
    currentNodeId: '',

    //当前边线的源节点和目标节点ID
    currentEdgeSourceNodeId: '',
    currentEdgeTargetNodeId: '',

    //线缆列表
    cableList: [],

    //失效线缆列表
    missCableList: [],

    //默认线缆id
    cableId: cache.get('cableId'),

    cableProductId: cache.get('cableProductId'),
    moduleProductId: cache.get('moduleProductId'),

    //默认线缆颜色
    cableColor: cache.get('cableColor'),

    cachedEdgeProperties: {
      cableId: null as number | null,
      edgeColor: '',
      strokeWidth: 1,
      borderStyle: 'solid',
      startArrow: 'none',
      endArrow: 'none',
      lineType: 'line', // 'line' | 'curve'
      cableProductId: '',
      moduleProductId: '',
    },
    //缓存文字属性
    cachedTextProperties: {
      fontColor: '#19191A',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: 12,
    },
    pendingToolbarAction: null as { method: string; args: any[] } | null,
  }),
  getters: {
    // 获取当前缩放级别
    currentScale: state => state.transform.SCALE_X,
    // 获取图表数据
    graphData: state => ({
      nodes: state.nodes,
      edges: state.edges,
    }),
    // 判断画布是否为空
    isCanvasEmpty: state => state.nodes.length === 0 && state.edges.length === 0,
    // 获取指定类型的节点
    nodesByType: state => (type: string) => state.nodes.filter(node => node.type === type),
    getCurrentProductId: state => state.currentProductId,
  },
  actions: {
    // 设置LogicFlow实例
    setLogicFlow(logicFlow: LogicFlow) {
      this.logicFlow = logicFlow
    },
    // 设置节点
    setNodes(nodes: NodeData[]) {
      this.nodes = nodes
    },
    // 设置边
    setEdges(edges: EdgeData[]) {
      this.edges = edges
    },
    setTransform(transform: { SCALE_X: number; SCALE_Y: number; TRANSLATE_X: number; TRANSLATE_Y: number }) {
      this.transform = transform
    },
    setDrawerComponentType(type: string) {
      this.drawerComponentType = type
    },
    setShowDrawerPanel(show: boolean) {
      this.showDrawerPanel = show
    },
    setShowPlaceDevices(show: boolean) {
      this.showPlaceDevices = show
    },
    setCurrentTextSize(size: number) {
      this.currentTextSize = size
    },
    setCurrentTextNodeId(id: string) {
      this.currentTextNodeId = id
    },
    setCurrentProductId(id: string) {
      this.currentProductId = id
    },
    setCurrentNodeId(id: string) {
      this.currentNodeId = id
    },
    setCurrentEdgeSourceNodeId(id: string) {
      this.currentEdgeSourceNodeId = id
    },
    setCurrentEdgeTargetNodeId(id: string) {
      this.currentEdgeTargetNodeId = id
    },
    setCableId(id: number) {
      this.cableId = id
    },
    setCableColor(color: string) {
      this.cableColor = color
    },
    setCableProductId(id: string) {
      this.cableProductId = id
    },
    setModuleProductId(id: string) {
      this.moduleProductId = id
    },
    setMissCableList(list: any[]) {
      this.missCableList = list
    },

    //缓存边线属性-用于下一次连接边线时使用
    updateCachedEdgeProperties(edgeProperties: any) {
      this.cachedEdgeProperties = {
        cableId: edgeProperties.cableId || this.cableId,
        edgeColor: edgeProperties.edgeColor || this.cableColor || '#19191A',
        strokeWidth: edgeProperties.strokeWidth || 1,
        borderStyle: edgeProperties.borderStyle || 'solid',
        startArrow: edgeProperties.startArrow || 'none',
        endArrow: edgeProperties.endArrow || 'none',
        lineType: edgeProperties.lineType || 'line',
        cableProductId: edgeProperties.cableProductId ?? this.cableProductId,
        moduleProductId: edgeProperties.moduleProductId ?? this.moduleProductId,
      }
    },
    getCachedEdgeProperties() {
      return { ...this.cachedEdgeProperties }
    },

    updateCachedTextProperties(textProperties: any) {
      this.cachedTextProperties = {
        fontColor: textProperties.fontColor || this.cachedTextProperties.fontColor,
        fontWeight: textProperties.fontWeight || this.cachedTextProperties.fontWeight,
        fontStyle: textProperties.fontStyle || this.cachedTextProperties.fontStyle,
        fontSize: textProperties.fontSize || this.cachedTextProperties.fontSize,
      }
    },
    getCachedTextProperties() {
      return { ...this.cachedTextProperties }
    },

    triggerToolbarAction(method: string, args: any[] = []) {
      this.pendingToolbarAction = { method, args }
    },
    clearPendingToolbarAction() {
      this.pendingToolbarAction = null
    },
  },
})
